function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorder = function SvgBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.142 628.976V145.815l256.814.537 13.5 61.106 176.37.907-1.03 277.722-189.16-.908-13.452-60.395H99.846l1.03 204.73zm293.761-201.253H441.93l-1.03-162.808H278.19l-13.501-61.106H99.846l1.03 163.519h224.527z",
    style: {
      strokeWidth: 0.710532
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M606.257 1024.678V680.055h189.175l9.63 43.585 130.321.675v200.901l-139.444-.676-9.595-43.078H652.008v143.216Zm215.529-143.93h73.486V767.432H779.215l-9.63-43.585H652.008V837.67h160.149z",
    style: {
      strokeWidth: 0.506799
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m718.589 177.478-59.666 312.817-139.16 127.263-154.83 56.304-110.74 232.069-199.849 59.814",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 60,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgBorder;